import { ClientType } from 'modules/onboarding/common/components';

import { CompanyStateRegistration } from '../../components';
import { useLegalRepresentativeCompanyStateRegistration } from '../../hooks';
import { PageComponentProps } from '../../types';

export const LegalRepresentativeCompanyStateRegistrationStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    files,
    goToBack,
    initialValues,
    onAddFiles,
    onRemoveFile,
    onSubmit,
    submitDisabled,
    submitLoading,
  } = useLegalRepresentativeCompanyStateRegistration();

  return (
    <CompanyStateRegistration
      canGoBack={canGoBack}
      clientType={ClientType.ClientRepresentative}
      files={files}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
